import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { defaultWhiteLabelProps } from '../../utils/helper';

export enum authStatusEnum {
  LANDED = 'LANDED',
  CONTINUED = 'CONTINUED',
  REJECTED = 'REJECTED',
  TIMER = 'TIMER',
  AUTHENITICATED = 'AUTHENITICATED',
  ENDED = 'ENDED',
  SUBMITTED = 'SUBMITTED',
  EXPIRY = 'EXPIRY',
  THANKYOU = 'THANKYOU',
}

export enum BrandDetailsLocation {
  ASSESSMENT_ENDFLOW = 'ASSESSMENT_END_FLOW',
  AUTHENTICATION = 'AUTHENTICATION',
}

export interface AuthState {
  token: string | null;
  status: authStatusEnum;
  audioVideoStatus: boolean;
  darkMode: boolean;
  companyLogo: string;
  companyName: string;
  companyWebsite: string;
  companyFavicon: string;
  primaryColor: string;
  privacyPolicyUrl: string;
  termsOfServiceUrl: string;
  fullPageThreeDotsLoading: number;
  customerCare: string;
  companyWhiteLogo: string;
}

const initialState: AuthState = {
  token: null,
  status: authStatusEnum.LANDED,
  audioVideoStatus: false,
  darkMode: false,
  companyLogo: defaultWhiteLabelProps.companyLogo,
  companyWhiteLogo: '',
  companyName: defaultWhiteLabelProps.companyName,
  companyWebsite: defaultWhiteLabelProps.companyWebsite,
  companyFavicon: defaultWhiteLabelProps.companyFavicon,
  customerCare: defaultWhiteLabelProps.customerCare,
  primaryColor: defaultWhiteLabelProps.primaryColor,
  privacyPolicyUrl: defaultWhiteLabelProps.privacyPolicyUrl,
  termsOfServiceUrl: defaultWhiteLabelProps.termsOfServiceUrl,
  fullPageThreeDotsLoading: 0,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setStatus: (state, action: PayloadAction<authStatusEnum>) => {
      state.status = action.payload;
    },
    setAudioVideoStatus: (state, action: PayloadAction<boolean>) => {
      state.audioVideoStatus = action.payload;
    },
    setDarkMode: (state, action: PayloadAction<boolean>) => {
      state.darkMode = action.payload;
    },
    setFullPageThreeDotsLoading: (state, action: PayloadAction<number>) => {
      state.fullPageThreeDotsLoading = action.payload;
    },
    setCompanyLogo: (state, action: PayloadAction<string>) => {
      state.companyLogo = action.payload;
    },
    setCompanyWhiteLogo: (state, action: PayloadAction<string>) => {
      state.companyWhiteLogo = action.payload;
    },
    setCustomerCare: (state, action: PayloadAction<string>) => {
      state.customerCare = action.payload;
    },
    setCompanyName: (state, action: PayloadAction<string>) => {
      state.companyName = action.payload;
    },
    setCompanyWebsite: (state, action: PayloadAction<string>) => {
      state.companyWebsite = action.payload;
    },
    setCompanyFavicon: (state, action: PayloadAction<string>) => {
      state.companyFavicon = action.payload;
    },
    setPrimaryColor: (state, action: PayloadAction<string>) => {
      state.primaryColor = action.payload;
    },
    setPrivacyPolicyUrl: (state, action: PayloadAction<string>) => {
      state.privacyPolicyUrl = action.payload;
    },
    setTermsOfServiceUrl: (state, action: PayloadAction<string>) => {
      state.termsOfServiceUrl = action.payload;
    },
  },
});

export const {
  setToken,
  setStatus,
  setDarkMode,
  setCompanyLogo,
  setCompanyName,
  setCompanyWebsite,
  setCompanyFavicon,
  setPrimaryColor,
  setPrivacyPolicyUrl,
  setCustomerCare,
  setTermsOfServiceUrl,
  setFullPageThreeDotsLoading,
  setCompanyWhiteLogo,
} = authSlice.actions;

export default authSlice.reducer;
